import React, { useState, useEffect } from 'react';
import {  Modal, Table, Alert, Card, Spinner, Col } from '@themesberg/react-bootstrap';
import axios from "axios";
import Layout from "./../components/Layout";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { ChoosePhotoWidget } from "../components/Widgets";
import { BASE_URL } from '../constants';
const Tasks = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingTasks, setLoadingTasks] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [uploadedImage, setUploadedImage] = useState({ photoBefore: null, photoAfter: null });
  const [previewBefore, setPreviewBefore] = useState(null);
  const [previewAfter, setPreviewAfter] = useState(null);
  const [showTable, setShowTable] = useState(true);
 const [zoomImage, setZoomImage] = useState(null);
  const fetchTasks = async () => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("userData"));
    const userId = user.id;
  
    try {
      const response = await axios.get(`${BASE_URL}/tasks/assigned/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const tasks = response.data;
  
      // Separate tasks
      const pendingTasks = tasks.filter(task => task.status === 'Pending');
      const completedTasks = tasks
        .filter(task => task.status === 'Completed')
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); 
  
      const lastCompletedTask = completedTasks.length > 0 ? [completedTasks[0]] : [];
  
     
      setTasks([...pendingTasks, ...lastCompletedTask]);
  
    } catch (err) {
      console.error("Error fetching tasks:", err);
      setError("Failed to fetch tasks. Please try again.");
      setTimeout(() => setError(null), 3000);
    } finally {
      setLoadingTasks(false);
    }
  };
  
  
  useEffect(() => {
    fetchTasks();
  }, []);
  
  
  const fetchTaskDetails = async (taskId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/tasks/${taskId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSelectedTask(response.data); // Set the task details
    } catch (err) {
      console.error("Error fetching task details:", err);
    } 
  };
  useEffect(() => {
    if (successMessage) {
      const timeout = setTimeout(() => {
        setShowTable(false);
      }, 3000); // 3 seconds
  
      return () => clearTimeout(timeout); // cleanup
    }
  }, [successMessage]);
  
  const handleCloseModal = () => {
    setSelectedTask(null);
    setUploadedImage({ photoBefore: null, photoAfter: null });
    fetchTasks()
  };
  const handleBeforeImageChange = (e) => {
    const file = e.target.files[0];
    const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes
  
    // Check if a file is selected
    if (file) {
      // Check file size
      if (file.size > maxFileSize) {
        alert("File size exceeds 5MB. Please choose a smaller image.");
        return;
      }
  
      // Check if the file is an image
      if (!file.type.startsWith("image/")) {
        alert("Please upload an image file.");
        return;
      }
  
      // If valid, set the uploaded image and preview
      setUploadedImage((prev) => ({ ...prev, photoBefore: file }));
      setPreviewBefore(URL.createObjectURL(file));
    }
  };
  
  const handleAfterImageChange = (e) => {
    const file = e.target.files[0];
    const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file) {
   
      if (file.size > maxFileSize) {
        alert("File size exceeds 5MB. Please choose a smaller image.");
        return;
      }
  
      // Check if the file is an image
      if (!file.type.startsWith("image/")) {
        alert("Please upload an image file.");
        return;
      }

      setUploadedImage((prev) => ({ ...prev, photoAfter: file }));
      setPreviewAfter(URL.createObjectURL(file));
    }
  };
  
  const handleSaveChanges = async () => {
    setLoading(true);
    setError(null); 
    setSuccessMessage(null);
  
    if (!uploadedImage.photoBefore || !uploadedImage.photoAfter) {
      alert("Please select both 'Before' and 'After' images before saving changes.");
      return;
    }
  
    const formData = new FormData();
    formData.append("photoBefore", uploadedImage.photoBefore);
    formData.append("photoAfter", uploadedImage.photoAfter);
  
    try {
      const token = localStorage.getItem("token");
  
      const response = await axios.put(
        `${BASE_URL}/tasks/${selectedTask._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      const updatedTask = {
        ...selectedTask,
        photoBefore: response.data.photoBefore,
        photoAfter: response.data.photoAfter,
        status: "Completed",
      };
  
      // Update the task list in state immediately with the updated task
      setTasks((prevTasks) =>
        prevTasks.map((task) =>
          task._id === selectedTask._id ? updatedTask : task
        )
      );
  
      // Display success message
      setSuccessMessage("Your task has been successfully updated!");
      setTimeout(() => setSuccessMessage(null), 3000);
  
      // Clear the uploaded images
      setUploadedImage({ photoBefore: null, photoAfter: null });
  
      // Close the modal
      handleCloseModal();
    } catch (err) {
      console.error("Error updating task:", err);
      setError("Failed to update the task. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
  <Layout>
    <div className="container mt-5">
      <h2 className="text-center mb-4 text-primary">User Task</h2>

      {loadingTasks ? (
        <div className="text-center mb-3">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : tasks.length > 0 ? (
        <Card border="light" className="table-wrapper table-responsive shadow-sm mt-3" style={{ maxHeight: "500px" }}>
          <Card.Body className="pt-0">
            {error && <Alert variant="danger">{error}</Alert>}

            <Table responsive className="align-items-center table-flush">
              <thead>
                <tr className="text-center">
                  <th scope="col">Due Date</th>
                  <th scope="col">Task Name</th>
                  <th>Before Cleaning</th>
                  <th scope="col">After Cleaning</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {[...tasks]
                  .sort((a, b) => {
                    if (a.status === "Pending" && b.status !== "Pending") return -1;
                    if (a.status !== "Pending" && b.status === "Pending") return 1;
                    return new Date(a.dueDate) - new Date(b.dueDate);
                  })
                  .map((task) => (
                    <tr key={task._id} className="text-center">
                      <td>{new Date(task.dueDate).toLocaleDateString()}</td>
                      <td>{task.taskName}</td>
                      <td>
                        <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
                          {task.photoBefore ? (
                            <img
                              src={task.photoBefore}
                              alt="Before Cleaning"
                              className="img-fluid rounded me-2"
                              style={{ width: "50px", height: "50px", cursor: 'pointer' }}
                              onClick={() => setZoomImage(task.photoBefore)}
                            />
                          ) : (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "5px",
                              }}
                            >
                              <i className="fas fa-cloud-upload-alt" style={{ fontSize: "1.5rem", color: "#999" }}></i>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
                          {task.photoAfter ? (
                            <img
                              src={task.photoAfter}
                              alt="After Cleaning"
                              className="img-fluid rounded"
                              style={{ width: "50px", height: "50px", cursor: "pointer"  }}
                              onClick={() => setZoomImage(task.photoAfter)}
                            />
                          ) : (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "5px",
                              }}
                            >
                              <i className="fas fa-cloud-upload-alt" style={{ fontSize: "1.5rem", color: "#999" }}></i>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        <span
                          className={`badge ${task.status === "Completed" ? "bg-success" : "bg-warning"} text-light`}
                        >
                          {task.status}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => fetchTaskDetails(task._id)}
                          disabled={task.status === "Completed"}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            {/* Modal for editing the task */}
            {selectedTask && (
              <Modal show={true} onHide={handleCloseModal} size="lg" centered>
                <Modal.Header closeButton>
                  <Modal.Title>{selectedTask.taskName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>{selectedTask.description}</p>

                  {selectedTask.photoBefore && (
                    <div className="mt-3">
                      <img
                        src={selectedTask.photoBefore}
                        alt="Before Cleaning"
                        className="img-fluid rounded mb-3"
                        style={{ width: '200px', height: '200px',cursor: "pointer"  }}
                        onClick={() => setZoomImage(selectedTask.photoBefore)}
                      />
                    </div>
                  )}

                  {selectedTask.photoAfter && (
                    <div className="mt-3">
                      <img
                        src={selectedTask.photoAfter}
                        alt="After Cleaning"
                        className="img-fluid rounded mb-3"
                        style={{ width: '200px', height: '200px', cursor: "pointer"   }}
                        onClick={() => setZoomImage(selectedTask.photoAfter)}
                      />
                    </div>
                  )}

                  <Col xs={12}>
                    <ChoosePhotoWidget
                      title="Upload Before Cleaning Image"
                      id="beforeImageUpload"
                      photo={uploadedImage.photoBefore}
                      preview={previewBefore}
                      onChange={handleBeforeImageChange}
                    />
                  </Col>

                  <Col xs={12}>
                    <ChoosePhotoWidget
                      title="Upload After Cleaning Image"
                      id="afterImageUpload"
                      photo={uploadedImage.photoAfter}
                      preview={previewAfter}
                      onChange={handleAfterImageChange}
                    />
                  </Col>

                  {loading && (
                    <div className="text-center mb-3">
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  )}

                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}
                </Modal.Body>

                <Modal.Footer>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveChanges}
                    disabled={!uploadedImage.photoBefore || !uploadedImage.photoAfter}
                  >
                    Save Changes
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                    Close
                  </button>
                </Modal.Footer>
              </Modal>
            )}

            {/* Zoomed Image Modal */}
            {zoomImage && (
              <div
                className="modal show fade d-block"
                tabIndex="-1"
                onClick={() => setZoomImage(null)}
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="modal-content bg-transparent border-0 shadow-none">
                    <div className="modal-body text-center p-0 position-relative">
                      <button
                        type="button"
                        className="btn-close position-absolute top-0 end-0 m-2"
                        onClick={() => setZoomImage(null)}
                        aria-label="Close"
                        style={{ backgroundColor: 'white' }}
                      />
                      <img
                        src={zoomImage}
                        alt="Zoomed"
                        className="img-fluid rounded"
                        style={{ maxHeight: '90vh', maxWidth: '100%' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      ) : (
        <div className="card mt-3">
          <div className="card-body">
            <p className="card-text">Currently, there are no tasks assigned to you.</p>
          </div>
        </div>
      )}
    </div>
  </Layout>
);

};

export default Tasks;